exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.QS420-upload-img-page[data-v-5fef1568]{width:2.384rem;width:14.9rem\n}", "", {"version":3,"sources":["/home/jenkins/workspace/pipeline-10323-UAT-kmos-web-ci-cd-6005/html/PC/src/business/businessFile/QS420/QS420_uploadImg.vue"],"names":[],"mappings":";AACA,wCAAwC,eAAe,aAAa;CACnE","file":"QS420_uploadImg.vue","sourcesContent":["\n.QS420-upload-img-page[data-v-5fef1568]{width:2.384rem;width:14.9rem\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5fef1568","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/style-rem-loader??ref--1!./src/business/businessFile/QS420/QS420_uploadImg.vue
// module id = 1285
// module chunks = 2